import script from "./TressTheMyPagesChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressTheMyPagesChangePassword.vue?vue&type=script&setup=true&lang=ts"

import "./TressTheMyPagesChangePassword.vue?vue&type=style&index=0&id=44a5a37d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a5a37d"]])

export default __exports__